<template>
    <sys-register-base 
        :loading="loading" 
        @onSave="save" 
        :model.sync="model" 
        :title="title" 
        :icon="icon"
        v-bind:show.sync="dialog"
        maxWidth="50%"
        :disabledSave="!!(model.id && model.term_signature_status_id == 2)"
    >
        <template v-slot:form>
            <v-container>
                    <v-row>
                        <v-col cols="12" sm="12">
                            <sys-select-teacher
                                :model.sync="model.teacher_ids"
                                :data="model.id && model.teacher ? model.teacher : null"
                                :error="errors.teacher_ids && errors.length > 0" 
                                :errors="errors.teacher_ids"
                                label="Professor(es)*"
                                autoComplete
                                multiple
                            />
                            <span class="caption grey--text">Selecione um ou mais professores</span>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="12" sm="8">
                            <sys-select-term
                                :model.sync="modelTermIds"
                                :data="model.id && model.term ? model.term : null"
                                :error="errors.term_ids && errors.term_ids.length > 0" 
                                :errors="errors.term_ids"
                                label="Termo(s)*"
                                autoComplete
                                :multiple="!model.id"
                            />
                            <span v-if="!model.id" class="caption grey--text">Selecione um ou mais termos</span>
                        </v-col>
                        <v-col cols="12" sm="4" v-if="model.id">
                            <sys-select-term-signature-status
                                :model.sync="model.term_signature_status_id"
                                :error="errors.term_signature_status_id && errors.length > 0" 
                                :errors="errors.term_signature_status_id"
                                label="Status*"
                                autoComplete
                            />
                        </v-col>
                        <v-col cols="12" sm="4" v-else>
                            <v-switch
                                v-model="model.send_immediately"
                                label="Enviar imediatamente"
                                :disabled="!model.teacher_ids || model.teacher_ids.length > 1"
                                inset
                                hide-details
                                class="mt-0"
                            />
                            <span class="caption grey--text">
                                Se desligado, o termo fica pendente de envio e poderá ser enviado em lote depois.
                            </span>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="12" sm="12">
                            <v-textarea
                                :error="!!errors.note" 
                                :error-messages="errors.note" 
                                v-model="model.note" 
                                label="Observação"
                                :counter="255"
                                rows="2"
                                :rules="[v => (!v || v.length <= 255) || 'Máximo de 255 caracteres atingido']"
                                outlined
                                clearable
                            />
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="12" sm="12">
                            <v-textarea
                                :error="!!errors.note_user" 
                                :error-messages="errors.note_user" 
                                v-model="model.note_user" 
                                label="Observação do Usuário"
                                :counter="255"
                                rows="2"
                                :rules="[v => (!v || v.length <= 255) || 'Máximo de 255 caracteres atingido']"
                                outlined
                                clearable
                            />
                        </v-col>
                    </v-row>
            </v-container>
            <!-- Alert para mensagens -->
            <emc-alert-snackbar :show="!! message.length"  :message="message" :color="error ? 'error' : 'success'"/>
        </template>
    </sys-register-base>
</template>

<script>

import { mapActions, mapState } from 'vuex'
export default {
    name: "SysRegisterTermSignature",
    data: (vm) => ({
        viewMenu: false,
        dialog: false,
        error: false,
        errors: {},
        range: null,
        message: '',
        loading: false,
    }),
    created(){
       
    },

    computed: {
      ...mapState('auth', ['acesso']),
      modelTermIds: {
        get() {
          if (!this.model) return [];
          const ids = this.model.term_ids;
          const single = this.model.term_id;
          if (Array.isArray(ids) && ids.length > 0) {
            return this.model.id ? ids[0] : ids;
          }
          if (single) return this.model.id ? single : [single];
          return this.model.id ? null : [];
        },
        set(val) {
          if (!this.model) return;
          const arr = Array.isArray(val) ? val : (val != null && val !== '' ? [val] : []);
          const normalized = arr.map(t => (typeof t === 'object' && t !== null && 'id' in t) ? t.id : t).filter(id => id);
          const current = Array.isArray(this.model.term_ids) ? this.model.term_ids : [];
          const currentIds = current.map(t => (typeof t === 'object' && t !== null && 'id' in t) ? t.id : t).filter(id => id);
          if (normalized.length === currentIds.length && normalized.every((id, i) => String(id) === String(currentIds[i]))) return;
          this.$set(this.model, 'term_ids', normalized);
          if (normalized.length === 1) this.$set(this.model, 'term_id', normalized[0]);
        }
      }
    },

    watch: {
        
        dialog(dialog_new, dialog_old) {
            
            if(dialog_new !== dialog_old) {
                this.$emit('update:show', dialog_new)
            }

        },

        show(show_new, show_old) {
            
            this.dialog = show_new;
            
            if(show_new && this.model){
                
                this.error = false;
                this.errors = {};
                this.range = null;

                if(!this.model.id){
                    this.model.send_immediately = false;
                    if(!Array.isArray(this.model.teacher_ids)){
                        this.$set(this.model, 'teacher_ids', []);
                    }
                    if(!Array.isArray(this.model.term_ids)){
                        this.$set(this.model, 'term_ids', []);
                    }
                } else {
                    const teacherId = this.model.teacher_id || (this.model.teacher && this.model.teacher.id);
                    const termId = this.model.term_id || (this.model.term && this.model.term.id);
                    this.$set(this.model, 'teacher_ids', teacherId ? [teacherId] : []);
                    this.$set(this.model, 'term_ids', termId ? [termId] : []);
                }
            }
        },
        
    },
    props: {
        model: {
            default: null
        },
        color: {
            type: String,
            default: 'grey lighten-5'
        },
        width: {
            type: String,
            default: "500"
        },
        maxWidth: {
            type: String,
            default: "80%"
        },
        icon: {
            type: String,
            default: "mdi-database-plus"
        },
        title: {
            type: String,
            default: "Cadastro de Assinatura"
        },
        text: {
            type: String,
            default: ""
        },
        show: {
            type: Boolean,
            default: false
        }
    },
    methods:{
        ...mapActions('term', ['ActionUpdateTermSignature', 'ActionCreateTermSignature', 'ActionUpdateTermSignatureGenerate']),

        save(edit)
        {
            this.error = false;
            this.message = '';
            this.errors = {};
            this.loading = true;

            const raw = Array.isArray(this.model.teacher_ids) ? this.model.teacher_ids : (this.model.teacher_ids ? [this.model.teacher_ids] : []);
            const teacherIds = raw.map(t => (typeof t === 'object' && t !== null && 'id' in t) ? t.id : t).filter(id => id);

            if (!teacherIds.length) {
                this.errors.teacher_ids = ['Selecione ao menos um professor'];
                this.loading = false;
                return;
            }

            const rawTerms = Array.isArray(this.model.term_ids) ? this.model.term_ids : (this.model.term_id ? [this.model.term_id] : []);
            const termIds = rawTerms.map(t => (typeof t === 'object' && t !== null && 'id' in t) ? t.id : t).filter(id => id);

            if (!termIds.length) {
                this.errors.term_ids = ['Selecione ao menos um termo'];
                this.loading = false;
                return;
            }

            Object.assign(this.model, { institution_id: this.acesso.instituicao.id });

            if (edit) {
                Object.assign(this.model, { term_id: termIds[0] });
                this.ActionUpdateTermSignature(this.model)
                    .then((res) => {
                        this.message = res.message.success ? res.message.success : res.message;
                        this.$emit('onCompleted');
                    })
                    .catch((error) => {
                        this.error = true;
                        this.errors = error.errors || {};
                        this.message = error.message;
                    })
                    .finally(() => {
                        this.loading = false;
                    });
            } else if (teacherIds.length === 1 && termIds.length === 1) {
                this.ActionCreateTermSignature({
                    ...this.model,
                    teacher_id: teacherIds[0],
                    term_id: termIds[0],
                    send_immediately: !!this.model.send_immediately
                })
                    .then((res) => {
                        this.message = res.message.success ? res.message.success : res.message;
                        this.$emit('onCompleted', res.data);
                    })
                    .catch((error) => {
                        this.error = true;
                        this.errors = error.errors || {};
                        this.message = error.message;
                    })
                    .finally(() => {
                        this.loading = false;
                    });
            } else if (teacherIds.length === 1 && termIds.length > 1) {
                const promises = termIds.map(termId =>
                    this.ActionCreateTermSignature({
                        ...this.model,
                        teacher_id: teacherIds[0],
                        term_id: termId,
                        send_immediately: !!this.model.send_immediately
                    })
                );
                Promise.all(promises)
                    .then(() => {
                        this.message = `${termIds.length} assinaturas criadas para o professor`;
                        this.$emit('onCompleted');
                    })
                    .catch((error) => {
                        this.error = true;
                        this.errors = error.errors || {};
                        this.message = error.message;
                    })
                    .finally(() => {
                        this.loading = false;
                    });
            } else {
                const promises = termIds.map(termId =>
                    this.ActionUpdateTermSignatureGenerate({
                        teacher_ids: teacherIds,
                        term_id: termId,
                        institution_id: this.acesso.instituicao.id
                    })
                );
                Promise.all(promises)
                    .then((results) => {
                        const totalCreated = results.reduce((sum, r) => sum + (r.data?.created || 0), 0);
                        const totalTerms = termIds.length * teacherIds.length;
                        this.message = `Assinaturas criadas: ${totalCreated} (${termIds.length} termo(s) para ${teacherIds.length} professor(es))`;
                        this.$emit('onCompleted', { created: totalCreated, results });
                    })
                    .catch((error) => {
                        this.error = true;
                        this.errors = error.errors || {};
                        this.message = error.message;
                    })
                    .finally(() => {
                        this.loading = false;
                    });
            }
        },
    }
}
</script>